export default "__VITE_ASSET__DXm7p9CG__"